import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export enum HttpRequestType {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}

export interface OptionalHttpQueryInterface {
  headers?: any;
  params?: any;
  body?: any;
}

export interface HttpQueryInterface extends OptionalHttpQueryInterface {
  type: HttpRequestType;
  url: string;
}

export enum ErrorMessage {
  internalServerError = 'Internal server error',
  unknownError = 'Unknown Error',
  tokenExpired = 'token_expired',
  tooManyLoginAttempts = 'Too many login attempts. Try again later.',
  tokenInvalid = 'token_invalid',
}

export interface HttpErrorPotentialife {
  message: ErrorMessage;
}

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(public http: HttpClient) {}

  public request<T = any>(options: HttpQueryInterface): Observable<T> {
    switch (options.type) {
      case HttpRequestType.GET:
        return this.getQuery(options);
      case HttpRequestType.DELETE:
        return this.deleteQuery(options);
      case HttpRequestType.PATCH:
        return this.patchQuery(options);
      case HttpRequestType.PUT:
        return this.putQuery(options);
      case HttpRequestType.POST:
        return this.postQuery(options);
      default:
        throw new Error(`Unknown http request type: ${options.type}`);
    }
  }

  private buildOptions(optionsRequest: HttpQueryInterface): OptionalHttpQueryInterface {
    const options: OptionalHttpQueryInterface = {};

    if (optionsRequest.headers) {
      options.headers = new HttpHeaders({
        ...optionsRequest.headers,
      });
    }

    if (optionsRequest.params) {
      options.params = optionsRequest.params;
    }

    if (optionsRequest.body) {
      options.body = optionsRequest.body;
    }

    return options;
  }

  private getQuery(optionsRequest: HttpQueryInterface): Observable<any> {
    return this.http.get(optionsRequest.url, this.buildOptions(optionsRequest));
  }

  private postQuery(optionsRequest: HttpQueryInterface): Observable<any> {
    return this.http.post(optionsRequest.url, optionsRequest.body, this.buildOptions(optionsRequest));
  }

  private putQuery(optionsRequest: HttpQueryInterface): Observable<any> {
    return this.http.put(optionsRequest.url, optionsRequest.body, this.buildOptions(optionsRequest));
  }

  private patchQuery(optionsRequest: HttpQueryInterface): Observable<any> {
    return this.http.patch(optionsRequest.url, optionsRequest.body, this.buildOptions(optionsRequest));
  }

  private deleteQuery(optionsRequest: HttpQueryInterface): Observable<any> {
    return this.http.request('delete', optionsRequest.url, this.buildOptions(optionsRequest));
  }
}
